import _ from 'underscore';
import React, { useState } from 'react';

import {
  domChildren as domChildrenProps,
  serverContext as serverContextProps,
} from '@bingads-webui-campaign-react/props-mca';

export const ServerContext = React.createContext([
  {},
  _.noop,
]);

export const ServerContextProvider = (props) => {
  const {
    context,
    children,
  } = props;

  const [serverContext, setServerContext] = useState(context);

  return (
    <ServerContext.Provider value={[serverContext, setServerContext]}>
      {children}
    </ServerContext.Provider >
  );
};

ServerContextProvider.propTypes = {
  context: serverContextProps.isRequired,
  children: domChildrenProps.isRequired,
};
